import { StyleProp, View, ViewStyle } from "react-native";
import useStyle from "src/hooks/useStyle";
import { color } from "src/styles";
import { Text } from "src/swsh-native";
import {
	CommentBubbleHorizontalPadding,
	CommentBubbleLargeRadius,
	CommentBubbleVerticalPadding,
} from "../constants";

const CommentMessageUnsent = ({ style }: { style?: StyleProp<ViewStyle> }) => {
	const { theme } = useStyle();

	return (
		<View
			style={[
				{
					borderRadius: CommentBubbleLargeRadius,
					borderWidth: 1,
					overflow: "hidden",
					backgroundColor: color.BackgroundModal[theme],
					borderColor: color.Neutral[theme],
					paddingHorizontal: CommentBubbleHorizontalPadding,
					paddingVertical: CommentBubbleVerticalPadding,
				},
				style,
			]}
		>
			<Text color="Neutral">Message unsent</Text>
		</View>
	);
};
export default CommentMessageUnsent;
